import { Component, inject, OnInit, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { NotificationTemplatesService } from '../../../services/notifications/notification-templates-service';
import { NotificationTemplate } from '../../../models/notification-template';
import { AddTemplateForm } from '../../../@shared/forms/topics/add-template-form/add-template-form';

@Component({
  selector: 'app-config-templates',
  imports: [AddTemplateForm, TooltipModule, DialogModule],
  templateUrl: './config-templates.html',
  styleUrl: './config-templates.scss',
})
export class ConfigTemplates implements OnInit {
  private service = inject(NotificationTemplatesService);

  templates = signal<NotificationTemplate[]>([]);
  loading = signal(false);
  editDialogVisible = false;
  addDialogVisible = false;
  selectedTemplate: NotificationTemplate | null = null;

  deletingTemplate: NotificationTemplate | null = null;
  confirmDeleteVisible = false;
  deleteLoading = signal(false);

  ngOnInit() { this.loadTemplates(); }

  loadTemplates() {
    this.loading.set(true);
    this.service.getTemplates().pipe(
      finalize(() => this.loading.set(false))
    ).subscribe({
      next: (res) => {
        const raw = res.data as unknown;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray((raw as { content?: unknown[] })?.content)
            ? (raw as { content: unknown[] }).content
            : [];
        this.templates.set(list as NotificationTemplate[]);
      },
    });
  }

  openAdd() { this.addDialogVisible = true; }

  openEdit(t: NotificationTemplate) {
    this.selectedTemplate = t;
    this.editDialogVisible = true;
  }

  askDelete(t: NotificationTemplate) {
    this.deletingTemplate = t;
    this.confirmDeleteVisible = true;
  }

  cancelDelete() {
    this.confirmDeleteVisible = false;
    this.deletingTemplate = null;
  }

  confirmDelete() {
    if (!this.deletingTemplate) return;
    const id = this.deletingTemplate.id;
    this.deleteLoading.set(true);
    this.service.deleteTemplate(id)
      .pipe(finalize(() => this.deleteLoading.set(false)))
      .subscribe(() => {
        this.templates.update(list => list.filter(t => t.id !== id));
        this.cancelDelete();
      });
  }

  categoryLabel(cat: string): string {
    return cat ? cat.charAt(0) + cat.slice(1).toLowerCase() : '';
  }
}
